'use client'

import { Box, Stack, Typography, useTheme } from '@mui/material'
import classNames from 'classnames'
import ResponsiveImage from '../responsiveImage/responsiveImage'
import { StyledResource } from './resource.styles'
import { Button } from '../button/button'

export const MultiButtonResource = ({
  buttons = [], // Array of button objects: [{ href, cta, external, prompt, icon }, ...]
  title,
  desc,
  img,
  alt,
  ...props
}) => {
  const theme = useTheme()
  const hasImage = img && alt
  
  return (
    <StyledResource
      {...props}
      className="stack"
      direction={{ xs: 'column', md: hasImage ? 'row' : 'column' }}
      spacing={2}
      sx={{ paddingRight: '0 !important' }}
      alignSelf={{ sm: 'center' }}
    >
      {hasImage && (
        <Box sx={{ aspectRatio: '270 / 333', width: '100%', maxWidth: { xs: 'unset', md: '270px' } }}>
          <ResponsiveImage
            sx={{ width: '100%' }}
            src={img}
            alt={alt}
          />
        </Box>
      )}
      <Stack direction="column" justifyContent="center" className={`text ${!hasImage ? 'with-margin' : ''}`} >
        <Typography
          color="tertiary.main"
          fontWeight={theme.typography.fontWeightBold}
        >
          {title}
        </Typography>
        {desc && (
          <Typography>
            {desc}
          </Typography>
        )}
        <Stack 
          direction={{ xs: "column", md: "row" }}
          spacing={{ xs: 1, md: 2 }}
          gap={{ xs: 2, md: 0 }}
          sx={{ mt: desc ? 2 : 1 }}
        >
          {buttons.map((button, index) => (
            <Button
              key={index}
              sx={{ flex: { xs: 'unset', md: 1 }, width: { xs: '100% !important', md: 'auto' } }}
              fontWeight={700}
              href={button.href}
              target="_blank"
              className={classNames("blue")}
              external={button.external ? "true" : ""}
              prompt={button.prompt}
              icon={button.icon}
            >
              {button.cta}
            </Button>
          ))}
        </Stack>
      </Stack>
    </StyledResource>
  )
}